import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';

const ExcelViewer = ({ file, open, onClose, period }) => {
  const [sheets, setSheets] = useState([]);
  const [activeSheet, setActiveSheet] = useState(0);

  useEffect(() => {
    if (!file || !open) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, { type: 'array' });
      const parsed = workbook.SheetNames.map((sheetName) => {
        const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { defval: '' });
        const headers = Object.keys(rows[0] || {});
        return {
          name: sheetName,
          rows: rows.map((row, index) => ({ id: index + 1, ...row })),
          columns: headers.map((field) => ({ field, headerName: field, minWidth: 160, flex: 1 })),
        };
      });
      setSheets(parsed);
      setActiveSheet(0);
    };
    reader.readAsArrayBuffer(file);
  }, [file, open]);

  const active = sheets[activeSheet] || { rows: [], columns: [] };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Données du fichier importé</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography><strong>Fichier :</strong> {period?.file_name || file?.name || '-'}</Typography>
          <Typography><strong>Importé le :</strong> {period?.created_at ? new Date(period.created_at).toLocaleString('fr-FR') : '-'}</Typography>
          <Typography><strong>Statut :</strong> {String(period?.is_sync) === '1' ? 'Synchronisé' : 'Non synchronisé'}</Typography>
          <Typography><strong>Lignes ignorées :</strong> {Number(period?.ignored_count || 0)}</Typography>
        </Box>
        <Tabs value={activeSheet} onChange={(event, value) => setActiveSheet(value)} variant="scrollable" scrollButtons="auto">
          {sheets.map((sheet) => <Tab key={sheet.name} label={`${sheet.name} (${sheet.rows.length})`} />)}
        </Tabs>
        <Box sx={{ height: 520, mt: 1 }}>
          <DataGrid rows={active.rows} columns={active.columns} pageSize={10} rowsPerPageOptions={[10, 25, 50]} />
        </Box>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fermer</Button></DialogActions>
    </Dialog>
  );
};

export default ExcelViewer;